/* eslint-disable jsx-a11y/label-has-for */

import { useState } from 'react';

import Bg from 'assets/images/SMSSentDialog.svg';
import { useTranslation } from 'providers/GILT.provider';

import PopupHeader from 'clientCommunications/components/Clients/ConfirmationModal/PopupHeader';
import PurchaseSmsCreditDialog from 'clientCommunications/components/Clients/PurchaseSmsCreditDialog';

export const NoSmsCredit = ({ isModalAction, history, closeNoSmsCreditModal, purchaseSmsBundle, salonId, errorMessage, gotoBilling, isFetching, sms_credits_available, permission }) => {
  const [openPurchaseModal, setOpenPurchaseModal] = useState(false);

  const { t } = useTranslation();

  return (
    <div data-bem="NoSmsCredit" className="dialog-container-marketing">
      {!openPurchaseModal && (
        <div className="popup-2-button animated zoomIn">
          <PopupHeader isModalAction={isModalAction} onClose={() => {}} history={history} style={{ background: `Url(${Bg})`, height: '414px', borderRadius: '4px' }}>
            <div className="flex-center">
              <div className="modal-content">
                <div className="sms-title">
                  <div>{t('scheduler.noSmsCreditModal.title')}</div>
                </div>
                <p className="uniq-note">{t('scheduler.noSmsCreditModal.description')}</p>
                <br />
              </div>
            </div>
          </PopupHeader>
          <div className="footer-marketing-sendsms cfix fromMarketing">
            <div className="marketing-button-container">
              <button className="sms-btn-white" onClick={closeNoSmsCreditModal} style={{ marginRight: '46px' }}>
                {t('scheduler.noSmsCreditModal.closeButton')}
              </button>
              <button className="sms-btn-violet" onClick={() => setOpenPurchaseModal(true)}>
                {t('scheduler.noSmsCreditModal.confirmButton')}
              </button>
            </div>
          </div>
        </div>
      )}
      {openPurchaseModal && (
        <PurchaseSmsCreditDialog
          closePopup={() => setOpenPurchaseModal(false)}
          purchaseSmsBundle={purchaseSmsBundle}
          salonId={salonId}
          errorMessage={errorMessage}
          gotoBilling={gotoBilling}
          isFetching={isFetching}
          sms_credits_available={sms_credits_available}
          fromRequestDeposit
          permission={permission}
          variantButton="normal"
        />
      )}
    </div>
  );
};
